'use client';

import { createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Import directly from redux-persist


export const popupSlice = createSlice({
  name: 'pupup',
  initialState: {
    isOpen: false,
  },
  reducers: {
    setIsOpen: (state, action) => {
      state.isOpen = action.payload;
    }
  },
});

export const { setIsOpen } = popupSlice.actions;

const persistConfig = {
    key: 'popup',
    storage: storage
}

export default persistReducer(persistConfig, popupSlice.reducer);
